export default __webpack_public_path__ + "static/dateFilter-20155aea42436ed7234e9434753d153d.gif";